import {negativeCircleSvg as Icon__small__negativeCircleSvg} from '../Icon__small/Icon__small--negativeCircle.js';

export var negativeCircle = {
  name: 'negativeCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__negativeCircleSvg,
};
